import { ActionTree } from "vuex";
import { IReceptionState } from "./state";
import { IReceptionDay, IReception, IReceptionNotification, ISupplier, ISlot } from "@/models";
import { AxiosResponse } from "axios";
import { apiClient } from "@/services";
import {
    ADD_RECEPTION_DAYS,
    ADD_NOTIFICATIONS,
    SET_RECEPTION_START_SLOT,
    SET_RECEPTION_END_SLOT,
} from "./mutations-types";
import moment from "moment";

export const actions: ActionTree<IReceptionState, number> = {
    async fetchReceptionDay(context, data: any): Promise<AxiosResponse<IReceptionDay>> {
        const response = await apiClient.get<IReceptionDay>(`/receptions?day=${data}`);
        context.commit(ADD_RECEPTION_DAYS, response.data);

        return response;
    },

    async fetchNotifications(context): Promise<AxiosResponse<IReceptionNotification[]>> {
        const response = await apiClient.get<IReceptionNotification[]>(`/receptions/notifications`);
        context.commit(ADD_NOTIFICATIONS, response.data);
        return response;
    },

    async addReceptionValidation(context, data: any): Promise<AxiosResponse<void>> {
        const response = await apiClient.post<void>(`/receptions/validate`, data);

        context.commit("CLEAN_RECEPTION");

        return response;
    },

    async addReception(context, data: any): Promise<AxiosResponse<void>> {
        const response = await apiClient.post<void>(`/receptions`, data);
        return response;
    },

    addValidationPicture(context, data: string): void {
        context.commit("ADD_VALIDATION_PICTURE", data);
    },

    removeValidationPicture(context, data: number): void {
        context.commit("REMOVE_VALIDATION_PICTURE", data);
    },

    async addAskAppointment(context, data: any): Promise<AxiosResponse<void>> {
        const response = await apiClient.post<void>(`/receptions/ask`, data);
        return response;
    },

    async deleteReception(context, receptionId: number): Promise<AxiosResponse<void>> {
        const response = await apiClient.delete(`/receptions/${receptionId}`);
        return response;
    },

    async editReception(context, reception: IReception): Promise<AxiosResponse<void>> {
        const response = await apiClient.put(`/receptions/${reception.receptionId}`, reception);
        return response;
    },

    async exportReceptions(context): Promise<AxiosResponse<void>> {
        const response = await apiClient.get(`/receptions/export`, { responseType: "blob" });
        return response;
    },

    async exportReceptionsPurchaseOrder(context, data: any): Promise<AxiosResponse<void>> {
        const day = moment(data.day);
        const response = await apiClient.get(`/receptions/export/${data.supplier.supplierId}/${day.format("YYYY-MM-DD")}`, { responseType: "blob" });
        return response;
    },

    async fetchReceptionStartSlot(context): Promise<AxiosResponse<ISlot>> {
        const response = await apiClient.get<ISlot>("/slots/ReceptionStartSlot");
        context.commit(SET_RECEPTION_START_SLOT, response.data);

        return response;
    },

    async fetchReceptionEndSlot(context): Promise<AxiosResponse<ISlot>> {
        const response = await apiClient.get<ISlot>("/slots/ReceptionEndSlot");
        context.commit(SET_RECEPTION_END_SLOT, response.data);

        return response;
    },

    async updateReceptionSlots(context, data: any): Promise<AxiosResponse<void>> {
        const response = await apiClient.post<void>(`/slots/UpdateReceptionSlots/${data.startSlotId}/${data.endSlotId}`);
        return response;
    },
};
